import React, { useState, useEffect, useCallback } from 'react';
import api from '../../../api';
import jwt_decode from 'jwt-decode';

const ShopLotsLayer = ({ camX, camY, onShopLotClick }) => {
  const [shopLots, setShopLots] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get user ID from JWT token
  const getUserId = () => {
    try {
      // Try to get user ID from JWT token first
      const token = localStorage.getItem("jwtToken");
      if (token) {
        const decoded = jwt_decode(token);
        if (decoded.id) {
          return decoded.id;
        }
      }
      
      // Fallback to authUser if token is invalid or not present
      const user = localStorage.getItem("authUser");
      return user ? JSON.parse(user).id : null;
    } catch (error) {
      return null;
    }
  };

  const fetchShopLots = useCallback(async () => {
    try {
      setLoading(true);
      
      // Fetch available lots
      const response = await api.get('/v1/player-shops/available-lots', { withCredentials: true });
      const availableLots = response.data || [];
      
      // Fetch all rented lots (including other players')
      const allRentedResponse = await api.get('/v1/player-shops/all-rented-lots', { withCredentials: true });
      const allRentedLots = allRentedResponse.data || [];
      
      // Combine all lots
      const allLots = [...availableLots, ...allRentedLots];
      
      // Process lots into NPCs
      const processedLots = allLots.map(lot => ({
        id: `ShopLot_${lot.id}`,
        x: lot.x_position,
        y: lot.y_position,
        width: 16,
        height: 24,
        sprite: lot.owner_id ? "/Trainers/Player.png" : "/Trainers/shop-empty.png",
        name: lot.owner_id ? `${lot.owner_username}` : `Lot #${lot.lot_number}`,
        modalType: lot.owner_id ? 
          (lot.owner_id.toString() === getUserId()?.toString() ? "playerShopManage" : "playerShopBrowse") : 
          "playerShopLot",
        lotId: lot.id,
        ownerId: lot.owner_id,
        status: lot.status
      }));
      
      setShopLots(processedLots);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchShopLots();
  }, [fetchShopLots]);

  if (loading || shopLots.length === 0) {
    return null;
  }

  return (
    <>
      {shopLots.map(lot => (
        <div
          key={lot.id}
          className="shop-lot"
          onClick={() => onShopLotClick(lot)}
          style={{
            position: 'absolute',
            left: lot.x - camX,
            top: lot.y - camY,
            width: lot.width,
            height: lot.height,
            backgroundImage: `url(${lot.sprite})`,
            backgroundPosition: '0 0',
            cursor: 'pointer',
            zIndex: 100,
            imageRendering: 'pixelated'
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-20px',
              left: '50%',
              transform: 'translateX(-50%)',
              whiteSpace: 'nowrap',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              color: 'white',
              padding: '2px 5px',
              borderRadius: '3px',
              fontSize: '10px'
            }}
          >
            {lot.name}
          </div>
        </div>
      ))}
    </>
  );
};

export default ShopLotsLayer;
